// extracted by mini-css-extract-plugin
module.exports = {"content":"content___bg9zN","title":"title___10Uav","featuredAuthor":"featuredAuthor___2BMq6"};